import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import BIMDigitalTwin from "./BIMDigitalTwin/BIMDigitalTwin";
import ApiAuthorizationRoutes from "./auth/ApiAuthorizationRoutes";
import { ApplicationPaths } from "./auth/ApiAuthorizationConstants";
import AuthorizeRoute from "./auth/AuthorizeRoute";
import { PanelAppProvider } from "./PanelAppProvider";

const App = (): JSX.Element => {
    // TODO Get user config
    // Modules avaiable
    // Role
    // Misc config

    return (
        <PanelAppProvider>
            <Switch>
                <Route exact path="/">
                    <Redirect to="/app" />
                </Route>
                <AuthorizeRoute path="/app" component={BIMDigitalTwin} />
                <Route
                    path={ApplicationPaths.ApiAuthorizationPrefix}
                    component={ApiAuthorizationRoutes}
                />
                <Route path="*">{/* TODO 404 component */}</Route>
            </Switch>
        </PanelAppProvider>
    );
};

// https://login.microsoftonline.com/549795f2-fcf2-4292-8821-d406b0bd7ea2/oauth2/v2.0/authorize?client_id=2fa513cb-d297-4176-adfb-5d32d0ccc1e8&redirect_uri=https%3A%2F%2Flocalhost%3A5001%2Fauthentication%2Flogin-callback&response_type=code&scope=openid%20profile%20email%20offline_access%20api%3A%2F%2Ff9caf40a-9521-4c62-9385-af58e072a5d0%2Ffull%20User.Read&state=14fc13507e4b4a6f970c71d05eacd80a&code_challenge=YxTjDFdq2C4aoOrCb02NtFXfHlt8Z7j_yetzG0LshEk&code_challenge_method=S256&response_mode=query&sso_reload=true
// https://login.microsoftonline.com/549795f2-fcf2-4292-8821-d406b0bd7ea2/oauth2/v2.0/authorize?client_id=2fa513cb-d297-4176-adfb-5d32d0ccc1e8&redirect_uri=https%3A%2F%2Flocalhost%3A5001%2Fauthentication%2Flogin-callback&response_type=code&scope=openid%20profile%20email%20offline_access%20api%3A%2F%2Ff9caf40a-9521-4c62-9385-af58e072a5d0%2Ffull%20User.Read&state=c69fe0fe15e740099e00ab25fc75338b&code_challenge=Di3_f-fl8VCGEsOzNTlKc6esZtbvqgzbD-Kl6HDqxrE&code_challenge_method=S256&response_mode=query&sso_reload=true

export default App;
